<div *ngIf="loading" class="loader">
  <div class="spinner-border" role="status"></div>
</div>
<main class="function">
  <header class="function--header">
    <div class="function--header__container">
      <h5 class="function--header__title">
        {{ 'newRequestFunctionTitle' | i18next }}
      </h5>
      <div id="stepperHeader"></div>
    </div>
  </header>
  <app-stepper
    [user]="user"
    [requestType]="requestType"
    [steps]="steps"
    (sendRequestEmitter)="sendRequest($event)"
  ></app-stepper>
</main>
